import AjaxUtil from "../../../axios/axios";


export const updateSubmissionInfo = async(data, id) => {
    try {
        return await AjaxUtil.sendRequest(`addsubmissioninfo/${id}`, data , false, { method: 'post', showError: true, isDocument: true} );
    } catch (error) {
        throw error;
    }
}